import request from '@/utils/request';

// larkSwtich列表查询
export function projectSwitchList(data) {
	return request({
		url: '/ocs-project/project/switch/list.json',
		method: 'post',
		data
	})
}

// 修改、新增品牌与larkSwtich关联
export function projectSwitchEditBrandLarkSwtich(data) {
	return request({
		url: '/ocs-project/project/switch/editBrandLarkSwtich.json',
		method: 'post',
		data: data,
		contentType: 'formData'
	})
}